import useHttpMutation from 'data/firestore/useHttpMutation';

const useDeleteResponder = () => useHttpMutation({
    method: 'DELETE',
});

export default useDeleteResponder;
